import questionService from '../services/QuestionService';
import lessonManager from '../managers/LessonManager';

import { ClozeBehavior } from './ClozeBehavior';

export class ClozeDragDropBehavior extends ClozeBehavior {
  // TODO phase out responseAnswer in favor of `lessonElementState.currentResponseAnswer`
  setResponseData = (data, _responseAnswer, model, { dataId, lessonElementState, oldDataId } = {}) => {
    const payload = data ? { ...data, dataId, answerId: data.id } : data;
    if (!lessonElementState.currentResponseAnswer.userInputMap) {
      const userInputMap = questionService.updateUserInputMap({ model, lessonElementState });
      if (dataId) {
        userInputMap.set(dataId, payload);
      }
      if (oldDataId) {
        userInputMap.set(oldDataId, {
          dataId: oldDataId,
          text: ''
        });
      }
    } else {
      if (dataId) {
        lessonElementState.currentResponseAnswer.userInputMap.set(dataId, payload);
      }
      if (oldDataId) {
        lessonElementState.currentResponseAnswer.userInputMap.set(oldDataId, {
          dataId: oldDataId,
          text: ''
        });
      }
    }
    lessonManager.stampResponsePublisherTranslationId(lessonElementState?.currentResponseAnswer);
  }
}

export default new ClozeDragDropBehavior();
